import { type VolumeBasedPriceV1 } from '@redteclab/api/clients/bully'

const getDiscountRanges = (
  volumePrices: VolumeBasedPriceV1[] = []
): RangesData[] => {
  const sortedVolumePrices = [...volumePrices].sort(
    (firstPrice, secondPrice) =>
      (firstPrice.quantityThreshold ?? 0) - (secondPrice.quantityThreshold ?? 0)
  )

  return sortedVolumePrices.map((discount, index) => {
    const rangeStart = discount.quantityThreshold ?? 0
    const nextDiscount =
      index + 1 < sortedVolumePrices.length
        ? sortedVolumePrices[index + 1]
        : undefined
    const rangeEnd = nextDiscount?.quantityThreshold
      ? nextDiscount.quantityThreshold - 1
      : undefined
    const discountPercentage = discount.discountPercentage ?? 0
    const range =
      rangeEnd && rangeStart !== rangeEnd
        ? `${rangeStart}-${rangeEnd}`
        : `${rangeStart}`
    const price =
      index === 0 && discount.unitDiscountPrice
        ? discount.unitDiscountPrice
        : discount.unitOriginPrice ?? 0

    return {
      discountPercentage,
      id: index,
      price,
      range,
      rangeEnd,
      rangeStart,
    }
  })
}
export const getDiscountForCurrentQuantity = (
  value: number,
  volumePricing: VolumeBasedPriceV1[]
): { discount?: number; quantity?: number } => {
  const ranges = getDiscountRanges(volumePricing ?? [])

  const getDiscountPercentage = (): number | undefined => {
    const discount = ranges.find(range =>
      range.rangeEnd === undefined
        ? value >= range.rangeStart
        : value >= range.rangeStart && value <= range.rangeEnd
    )

    return discount ? discount.discountPercentage : undefined
  }

  if (volumePricing) {
    for (const volumePrice of volumePricing) {
      if (
        value &&
        volumePrice.quantityThreshold &&
        volumePrice.discountPercentage !== null
      ) {
        return {
          discount: getDiscountPercentage(),
          quantity: volumePrice.quantityThreshold,
        }
      }
    }
  }

  return {
    discount: undefined,
    quantity: undefined,
  }
}

interface RangesData {
  discountPercentage?: number
  id: number
  price: number
  range: string
  rangeEnd?: number
  rangeStart: number
}
